import Vue from 'vue';
import Vuetify from 'vuetify';
import locales from '../locales';

import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
		iconfont: 'mdi'
	},
	lang: {
		locales,
		current: 'ru'
	}
});
